__turbopack_context__.v({
  "className": "aRdl1a_className",
  "variable": "aRdl1a_variable",
});
